module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.positionTooltip,
    staticStyle: {
      "lineheight": "5px"
    },
    on: {
      "mouseover": function($event) {
        _vm.isHover = true
      },
      "mouseleave": function($event) {
        _vm.isHover = false
      }
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.isHover) ? _c('div', {
    staticClass: "absolute z-10 rounded-md text-center font-manrope",
    class: [_vm.backgroundColor, _vm.styleTooltip, _vm.padding]
  }, [_c('span', {
    staticClass: "text-white block whitespace-nowrap font-normal",
    class: [_vm.textColor],
    staticStyle: {
      "font-size": "13px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6c2e8566!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Tooltip.vue
// module id = 921
// module chunks = 61